"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _hooks = require("../../../../hooks");

var _components = require("../../../../components");

var _TableInfoModule = _interopRequireDefault(require("./TableInfo.module.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var TableInfo = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var selectorText = _ref.selectorText,
      selectorButton = _ref.selectorButton,
      cellType = _ref.cellType,
      tableNumber = _ref.tableNumber,
      onClick = _ref.onClick;

  var _useTemplate$useCell = _hooks.useTemplate.useCell(cellType),
      views = _useTemplate$useCell.views,
      labelTextStyles = _useTemplate$useCell.labelTextStyles;

  return /*#__PURE__*/_react["default"].createElement(_components.View, {
    direction: "column",
    type: views.background,
    className: _TableInfoModule["default"].tableInfo
  }, /*#__PURE__*/_react["default"].createElement(_components.View, {
    type: views.primary,
    className: _TableInfoModule["default"]["tableInfo-title"]
  }, /*#__PURE__*/_react["default"].createElement(_components.Text, {
    type: labelTextStyles.primary
  }, selectorText)), /*#__PURE__*/_react["default"].createElement(_components.View, {
    type: views.secondary,
    className: _TableInfoModule["default"]["tableInfo-number"],
    onClick: onClick,
    role: "button",
    justify: "center"
  }, /*#__PURE__*/_react["default"].createElement(_components.Text, {
    type: labelTextStyles.tertiary,
    dangerouslySetInnerHTML: {
      __html: tableNumber
    }
  })), /*#__PURE__*/_react["default"].createElement(_components.Text, {
    type: labelTextStyles.secondary,
    className: _TableInfoModule["default"]["tableInfo-edit"],
    role: "button",
    onClick: onClick
  }, selectorButton));
});

var _default = TableInfo;
exports["default"] = _default;